import React from 'react';
import { Box } from '@mui/material';
import {
  PAGE_PADDING_X,
  PAGE_PADDING_Y,
  PAGE_MAX_WIDTH,
} from '../../shared-theme/tokens';

// すべての page-level 外殻を統一する primitive。
// max-width + 中央寄せ + 左右/上下 padding を一律に。
// 余白を子側で個別に持たせない → 機能ごとの「余白がバラバラ」問題を撲滅。
export default function PageContainer({ children, maxWidth = PAGE_MAX_WIDTH }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth,
        mx: 'auto',
        px: { xs: 2, md: PAGE_PADDING_X },
        py: PAGE_PADDING_Y,
      }}
    >
      {children}
    </Box>
  );
}
